/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useEffect, useState } from "react";

export const BusinessIdEffect = ({ currentBusinessId, setCurrentBusinessId, user }) =>
    useEffect(() => {
        if ((!currentBusinessId || currentBusinessId === "") && user?.BusinessDetails?.Code) {
            if (user?.BusinessDetails?.Offer?.LinkedBusiness?.length > 0) {
                setCurrentBusinessId("ALLJOBS");
            } else {
                setCurrentBusinessId(user.BusinessDetails.Code);
            }
        }
    }, [user]);

export const tabIndexEffect = ({
    currentBusinessId,
    setLoading,
    collection_tab_index,
    containerMode,
    doSearch,
    searchFilter,
    sortBy,
    main_page,
}) =>
    useEffect(() => {
        if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache"))
            return;
        if (currentBusinessId !== "") {
            setLoading(true);
            if (collection_tab_index === 0) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 1) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 2) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 3) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            }
        }
    }, [currentBusinessId, collection_tab_index]);

export const sortByEffect = ({
    loading,
    doSearch,
    searchFilter,
    currentBusinessId,
    containerMode,
    sortBy,
    collection_tab_index,
    main_page,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (loading) return;

        doSearch({
            terms: searchFilter,
            currentBusinessId,
            containerMode,
            sortBy,
            collection_tab_index,
            NumRecallItems: main_page.NumRecallItems,
        });
    }, [sortBy]);
};

export const searchEffect = ({
    setLoading,
    sortBy,
    searchFilter,
    delayedSearch,
    containerMode,
    currentBusinessId,
    collection_tab_index,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        setLoading(true);
        delayedSearch({
            terms: searchFilter,
            currentBusinessId,
            containerMode,
            sortBy,
            collection_tab_index,
        });
    }, [searchFilter]);
};

export const containerModeEffect = ({
    containerMode,
    setLoading,
    API_BASE,
    fetchTimeout,
    dispatch,
    updateAPP,
    doSearch,
    searchFilter,
    currentBusinessId,
    sortBy,
    collection_tab_index,
    main_page,
    setIntialise,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (containerMode === "") return;
        setLoading(true);
        let api_url = API_BASE() + "business" + (containerMode ? "/" + containerMode : "");

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                dispatch(updateAPP("DistributorList", json)).then((e) => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
                setIntialise(true);
            })
            .catch((e) => {
                dispatch(updateAPP("DistributorList", []));
            });
    }, [containerMode]);
};

export const initialiseEffect = ({ intialise, user, API_BASE, fetchTimeout, setIntialise, dispatch, updateAPP }) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (window.debug && window.location.href.includes("static")) return;
        if (!intialise && user?.Role) {
            if (user?.Role >= 90) {
                let api_url = API_BASE() + "business/";
                fetchTimeout(api_url, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((json) => {
                        dispatch(updateAPP("DistributorList", json));
                        setIntialise(true);
                    })
                    .catch((e) => {
                        dispatch(updateAPP("DistributorList", []));
                    });
            }
        }
    }, [intialise, user]);
};

export const mainPageEffect = ({
    containerMode,
    setLoading,
    doSearch,
    searchFilter,
    currentBusinessId,
    sortBy,
    collection_tab_index,
    main_page,
    user,
    loading,
    updateRecallListFromWeb,
    page,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (user?.id && !loading) {
            setLoading(true);

            if (collection_tab_index === 0) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 1) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 2) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            } else if (collection_tab_index === 3) {
                doSearch({
                    terms: searchFilter,
                    currentBusinessId,
                    containerMode,
                    sortBy,
                    collection_tab_index,
                    NumRecallItems: main_page.NumRecallItems,
                });
            }
        }
    }, [main_page, page]);
};

export const uploadFileEffect = ({
    API_BASE,
    fetchTimeout,
    user,
    readComplete,
    fileData,
    setBackDrop,
    newDefaultJobState,
    config,
    setShowMessage,
    setDialogData,
}) =>
    useEffect(() => {
        if (readComplete && fileData.length > 0) {
            let filenames = [];
            for (let file of fileData)
                filenames.push(
                    <>
                        {file.name}
                        <br />
                    </>
                );

            setBackDrop(
                <>
                    Importing Files...
                    <br />
                    {filenames}
                </>
            );

            let api_url = API_BASE() + "JobImport/";
            fetchTimeout(
                api_url,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        imported_data: fileData,
                        job_template: newDefaultJobState(config, "", user),
                    }),
                },
                120000
            )
                .then((response) => response.json())
                .then((json) => {
                    if (json?.Error) {
                        throw json.Error;
                    }
                    setBackDrop(false);
                    setShowMessage({
                        type: "success",
                        message: json?.Success ? json?.Success : "Files Successfuly imported",
                    });
                })
                .catch((e) => {
                    setBackDrop(false);
                    setDialogData({
                        title: "Error importing Job Files",
                        message: [<>{e?.message ? e.message : e}</>],
                        primaryActionText: "OK",
                        primaryAction: () => {},
                    });
                });
        }
    }, [readComplete]);

export const useFetchJobPricesEffect = (API_BASE, fetchTimeout, businessCode, containerMode, dateRange, statusToShow) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!businessCode) {
            setError("Business code is missing.");
            setLoading(false);
            return;
        }

        setLoading(true);
        const endPoint = `${API_BASE()}job/dash/${businessCode}/`;

        fetchTimeout(endPoint, {
            method: "POST",
            body: JSON.stringify({
                Container: containerMode,
                StatusFilter: statusToShow,
                DateRange: dateRange,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                const jobsByStatus = Array.isArray(data.Status) ? data.Status.filter((group) => group.Status) : [];

                const sortByStatus = (statusGroups) => {
                    const statusOrder = ["LEAD", "QUOTED", "ORDERED", "INVOICED"];

                    return statusGroups.sort((a, b) => {
                        const indexA = statusOrder.indexOf(a.Status);
                        const indexB = statusOrder.indexOf(b.Status);

                        if (indexA !== -1 && indexB !== -1) {
                            return indexA - indexB;
                        }

                        if (indexA !== -1) return -1;
                        if (indexB !== -1) return 1;

                        return 0;
                    });
                };

                setTableData(sortByStatus(jobsByStatus));
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }, [businessCode, containerMode, dateRange, statusToShow]);

    return {
        dashData: tableData,
        dashLoading: loading,
        dashError: error,
    };
};
